import { SUBSCRIPTION_MANAGEMENT_LABELS } from '@/epics/subscriptionManagment/constants/translations/labels';

/** Base price after the service/equipment's own discount, if any. */
export const computeFinalPrice = (
  basePrice: number,
  discountPercentage: number | null
): number =>
  discountPercentage ? basePrice * (1 - discountPercentage / 100) : basePrice;

export interface OfferDiscount {
  discountType: 'PERCENTAGE' | 'FIXED';
  discountValue: number;
}

/**
 * Plan price after an offer's discount is applied — same formula as
 * AppliedOfferCard's own finalPrice calculation. Fixed discounts are
 * clamped at 0 (price can't go negative); no offer means price is
 * unchanged.
 */
export const computeOfferFinalPrice = (
  basePrice: number,
  discount: OfferDiscount | null
): number =>
  discount
    ? discount.discountType === 'PERCENTAGE'
      ? basePrice * (1 - discount.discountValue / 100)
      : Math.max(0, basePrice - discount.discountValue)
    : basePrice;

const CYCLE_SUFFIX: Record<string, string> = {
  monthly: SUBSCRIPTION_MANAGEMENT_LABELS.CYCLE_SUFFIX_MONTHLY.polish,
  quarterly: SUBSCRIPTION_MANAGEMENT_LABELS.CYCLE_SUFFIX_QUARTERLY.polish,
  yearly: SUBSCRIPTION_MANAGEMENT_LABELS.CYCLE_SUFFIX_YEARLY.polish,
};

/** "monthly" → "/mies.", "quarterly" → "/qtr", "yearly" → "/rok". */
export const getCycleSuffix = (cycleEnglish: string): string =>
  CYCLE_SUFFIX[cycleEnglish] ?? '';
